import { Resources } from 'constants/resources';

import { AxiosResponse, AxiosError } from 'axios';
import { axios } from 'config/axios';
import { RefundChargebackReportListFilterValues } from 'pages/Finance/RefundChargebackReport/RefundChargebackReportFilter/RefundChargebackReportFilter';
import qs from 'qs';
import { RefundChargebackReport } from 'types/embedded/refundChargebackReport';

export const getRefundChargebackReport = async (
  filter: RefundChargebackReportListFilterValues = {} as RefundChargebackReportListFilterValues,
): Promise<RefundChargebackReport> => {
  const params = qs.stringify(
    {
      ...filter,
    },
    { arrayFormat: 'indices', encode: true },
  );
  return axios
    .get(`${Resources.RefundChargebackReport}?${params}`)
    .then((response: AxiosResponse) => response.data)
    .catch((error: AxiosError) => Promise.reject(error.response));
};
